import { AuthActionTypes } from 'store/action-types';
import { User } from 'common/types';

export interface State {
  user: User | null;
}

const initialState: State = {
  user: null,
};

const userReducer = (state = initialState, action: AuthActionTypes.Action): State => {
  const { type } = action;

  switch (type) {
    case AuthActionTypes.ActionType.LOGIN:
      return handleLogin(state, action.payload!);

    case AuthActionTypes.ActionType.LOGOUT:
      return handleLogout(state);

    default:
      return state;
  }
};

function handleLogin(state: State, payload: State): State {
  return { ...state, user: payload.user };
}

function handleLogout(state: State) {
  return { ...state, user: null };
}

export default userReducer;
